import StoreModule from "@/utils/StoreModule";

const customsDeals = StoreModule("/customs/customs-deals");

export default customsDeals;
